import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HiPlay, HiLocationMarker, HiClock } from 'react-icons/hi';
import './NCReplays.css';
import '../pages/admin/NCAdmin.css';

export default function NCReplays({ config }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    loadGames();
  }, []);

  const loadGames = async () => {
    try {
      const res = await fetch(`${config.apiUrl}/games`);
      const data = await res.json();
      const recorded = (data.data.games || [])
        .filter(g => g.status === 'recorded' || g.status === 'ended')
        .sort((a, b) => new Date(b.scheduledStart) - new Date(a.scheduledStart));
      setGames(recorded);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const sports = ['all', ...new Set(games.map(g => g.sport).filter(Boolean))];
  const filtered = filter === 'all' ? games : games.filter(g => g.sport === filter);

  if (loading) return <div className="nc-replays-loading"><div className="loading-spinner" /></div>;

  return (
    <div className="nc-replays-page">
      <div className="nc-replays-header">
        <div className="nc-admin-eyebrow">NC LIVE</div>
        <h1 className="nc-admin-title">Replays</h1>
      </div>

      {sports.length > 1 && (
        <div className="nc-replays-filters">
          {sports.map(s => (
            <button
              key={s}
              className={`nc-filter-btn ${filter === s ? 'active' : ''}`}
              onClick={() => setFilter(s)}
            >
              {s.toUpperCase()}
            </button>
          ))}
        </div>
      )}

      {filtered.length === 0 ? (
        <div className="nc-replays-empty">
          <p>No replays available yet.</p>
        </div>
      ) : (
        <div className="nc-replays-grid-page">
          {filtered.map(game => {
            const isProcessing = game.status === 'ended' || !game.recordingUrl;
            const CardWrapper = ({ children }) => isProcessing
              ? <div key={game.gameId} className="nc-replay-card-page nc-replay-card-processing">{children}</div>
              : <Link key={game.gameId} to={`/watch/${game.gameId}`} className="nc-replay-card-page">{children}</Link>;
            return (
              <CardWrapper key={game.gameId}>
                <div className="nc-replay-thumb-page">
                  {game.thumbnailUrl && <img src={game.thumbnailUrl} alt="Match" />}
                  {isProcessing
                    ? <div className="nc-replay-processing-overlay">
                        <div className="loading-spinner nc-replay-processing-spinner" />
                        <span className="nc-replay-processing-label">Available Soon</span>
                      </div>
                    : <div className="nc-replay-overlay-page"><HiPlay /></div>
                  }
                  <div className="nc-replay-stripe-page" />
                </div>
                <div className="nc-replay-info-page">
                  <div className="nc-replay-sport-page">{game.sport?.toUpperCase()}</div>
                  <h3 className="nc-replay-teams-page">{game.homeTeam} vs {game.awayTeam}</h3>
                  <div className="nc-replay-meta-page">
                    <span><HiLocationMarker /> {game.venue}</span>
                    <span><HiClock /> {new Date(game.scheduledStart).toLocaleDateString('en-AU', {
                      weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
                    })}</span>
                  </div>
                </div>
              </CardWrapper>
            );
          })}
        </div>
      )}
    </div>
  );
}
